import React, { useState } from 'react';
import { ThumbUp, ThumbUpOutlined, ThumbDown, ThumbDownOutlined } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';

/**
 * Feedback component allows users to like or dislike content.
 * 
 * @param {Object} props - Component props
 * @param {Function} props.onLike - Callback function to be called when the like button is pressed
 * @param {Function} props.onDislike - Callback function to be called when the dislike button is pressed
 * 
 * @returns {JSX.Element} The rendered component
 */
const Feedback = ({ onLike, onDislike }) => {
    const [liked, setLiked] = useState(false);
    const [disliked, setDisliked] = useState(false);

    const handleLike = () => {
        if (liked) return;
        setLiked(true);
        setDisliked(false);
        onLike?.();
    };

    const handleDislike = () => {
        if (disliked) return;
        setDisliked(true);
        setLiked(false);
        onDislike?.();
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', pt: 1 }}>
            <IconButton
                disabled={liked || disliked}
                onClick={handleLike}
                style={{ marginRight: 8 }} // Inline styles for MUI v4
            >
                {liked ? (
                    <ThumbUp fontSize="small" color="disabled" />
                ) : (
                    <ThumbUpOutlined fontSize="small" />
                )}
            </IconButton>
            <IconButton disabled={liked || disliked} onClick={handleDislike}>
                {disliked ? (
                    <ThumbDown fontSize="small" color="disabled" />
                ) : (
                    <ThumbDownOutlined fontSize="small" />
                )}
            </IconButton>
        </Box>
    );
};

export default Feedback;
